import http from '../http'

export default {
    /**
     * Get all facturas from promotor
     * @returns {Promise}
     */
    all(usuario) {
        return http.get(`usuarios/${usuario}/facturacion/facturas`)
    },
}